import { reactive, computed } from 'vue';
const stores = {};

export function defineStore(id, { state, getters, actions }) {
  const storeState = state();

  const store = reactive(storeState);

  if (getters) {
    Object.keys(getters).forEach(key => {
      storeState[key] = computed(() => getters[key](store));
    });
  }

  if (actions) {
    Object.keys(actions).forEach(key => {
      store[key] = actions[key].bind(store);
    });
  }

  store.$reset = function() {
    Object.assign(store, state());
  };

  stores[id] = store;

  return function() {
    return stores[id];
  };
}

// TODO: expose module store, remove this after fully migrated
window.__APP__ = window.__APP__ || {};
window.__APP__.STORE = window.__APP__.STORE || {};
window.__APP__.STORE.STORES = stores;
